import { Settings2, Cpu, MessageSquare, LifeBuoy } from "lucide-react";
import { Reveal } from "./Reveal";
import { WHY_US } from "../lib/data";

const ICONS = { Settings2, Cpu, MessageSquare, LifeBuoy };

export const WhyUs = () => (
  <section id="why-us" className="relative py-20 sm:py-28 lg:py-32" data-testid="why-us-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl mb-14 sm:mb-16">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-laser">
          // Why Dotnet Services
        </span>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-4">
          Why Dotnet Services?
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {WHY_US.map((item, i) => {
          const Icon = ICONS[item.icon];
          return (
            <Reveal key={item.title} delay={i * 0.1}>
              <div
                data-testid={`why-us-card-${i}`}
                className="h-full rounded-2xl border border-border-subtle bg-card-dark/70 p-6 hover:border-electric/40 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="h-11 w-11 rounded-xl bg-electric/15 border border-electric/30 flex items-center justify-center mb-5">
                  <Icon size={20} className="text-laser" />
                </div>
                <h3 className="font-display text-lg font-semibold text-white mb-2">
                  {item.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed">{item.description}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
